import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { BiArrowBack } from 'react-icons/bi';
import PostedJobView from './PostedJobView';
import HoldJob from './HoldJob';
import ArchiveJobsList from './ArchiveJobsList';
import ExpiredJobsList from './ExpiredJobsList';
import AppliedJobsVendor from "./AppliedJobsVendor"
import { VendorProfile as VendorProfileAction } from "../../Redux/action/VendorProfileAction";
import { useDispatch, useSelector } from "react-redux";
import PostLaterJobs from './PostLaterJobs';

const PostedJobs = () => {
    const dispatch = useDispatch();
    const location = useLocation(); 

    const QueryParams = new URLSearchParams(location?.search);
    const vId = QueryParams?.get('vendorId');

    const currentTab = QueryParams?.get('active');
    const [activeTab, setActiveTab] = useState(currentTab ?? "posted");
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        dispatch(VendorProfileAction(vId));
        window.scrollTo(0, 0)
    }, [])
    return (
        <>
            <div className='custom_container'>

                <div className='common_wrapper mb-4 d-flex justify-content-between align-items-center' style={location.pathname.includes('admin') ? { fontSize: '14px', width: '95%', marginTop: '16px' } : { fontSize: '14px' }}>
                    <ul className="nav nav-pills justify-content-evenly">
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=posted&vendorId=${vId}` : `/posted_jobs?active=posted`}><button className={`nav-link ${activeTab === "posted" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("posted")}>Posted Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=post-later&vendorId=${vId}` : `/posted_jobs?active=post-later`}><button className={`nav-link ${activeTab === "post-later" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("post-later")}>Post later Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=drafted&vendorId=${vId}` : `/posted_jobs?active=drafted`}><button className={`nav-link  ${activeTab === "drafted" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("drafted")}>Drafted Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=expired&vendorId=${vId}` : `/posted_jobs?active=expired`}><button className={`nav-link  ${activeTab === "expired" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("expired")}>Expired Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=archive&vendorId=${vId}` : `/posted_jobs?active=archive`}><button className={`nav-link  ${activeTab === "archive" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("archive")}>Archived Jobs</button></Link>
                        </li>
                        <li className="nav-item">
                            <Link to={location.pathname.includes('admin') ? `/admin/posted_jobs?active=applied&vendorId=${vId}` : `/posted_jobs?active=applied`}><button className={`nav-link  ${activeTab === "applied" ? "active bg_primary color_white" : ""}`} onClick={() => handleTabChange("applied")}>Applied Jobs</button></Link>
                        </li>
                    </ul>

                    {/* <Link to="/create_job" className="pdtn">
                            <button type="button" className="common_btn me-3">
                                Create New Job
                            </button>
                        </Link> */}
                </div>
                <div style={{ width: location.pathname.includes('admin') ? '95%' : '' }} className='common_wrapper'>
                    {activeTab === "posted" && <PostedJobView posted="POSTED" />}
                    {activeTab === "post-later" && <PostLaterJobs posted="POSTLATER" />}
                    {activeTab === "drafted" && <HoldJob posted="ONHOLD" activeTab={activeTab} setActiveTab={setActiveTab} />}
                    {activeTab === "expired" && <ExpiredJobsList posted="EXPIRED" />}
                    {activeTab === "archive" && <ArchiveJobsList posted="" />}
                    {activeTab === "applied" && <AppliedJobsVendor posted="" />}
                </div>
            </div>
        </>
    )
}

export default PostedJobs;
